export const isIOS = /iPhone|iPad|iPod/i.test(navigator?.userAgent)

export const isAndroid = /Android/i.test(navigator.userAgent)

export const isMac = /Mac/i.test(navigator.userAgent) && !isIOS
